const QUALIFICATION_ITEM_TYPES = Object.freeze({
  QUALIFIED: 'qualified',
  UNQUALIFIED: 'unqualified',
});

const REFERRED_TYPES = Object.freeze({
  INDIVIDUAL: 'individual',
  ORGANIZATION: 'organization',
});

export { QUALIFICATION_ITEM_TYPES, REFERRED_TYPES };
